export const loadingColors = {
  foreground: "rgba(255,255, 255, .8)",
  background: "#EFEFF2"
}